import { InputHTMLAttributes, PropsWithChildren, useMemo } from 'react'

import checkIcon from '~/assets/images/sprite/check.svg'
import { StyledOption as S } from '~/shared/components/Option/Option.styles'
import { SvgImage } from '~/shared/components/SvgImage'
import { OptionType } from '~/shared/constants/commonConstants'

export interface Props {
  name?: string
  checked?: boolean
  disabled?: boolean
  isCheckIconHidden?: boolean
  onChange?: (value: string, isChecked: boolean) => void
  type: OptionType
  value: string
}

export const Option = ({
  type,
  value,
  children,
  name,
  checked,
  disabled,
  onChange,
  isCheckIconHidden,
  ...rest
}: PropsWithChildren<Props>) => {
  const isCheckboxType = type === OptionType.CHECKBOX

  const inputProps = useMemo((): InputHTMLAttributes<HTMLInputElement> => {
    const props: InputHTMLAttributes<HTMLInputElement> = {
      value,
      type,
      onChange: ({ target }: React.ChangeEvent<HTMLInputElement>) =>
        onChange && onChange(target.value, target.checked),
    }

    if (name) {
      props.name = name
    }

    if (checked !== undefined) {
      props.checked = checked
    }

    if (disabled) {
      props.disabled = disabled
    }

    return props
  }, [checked, disabled, name, onChange, type, value])

  return (
    <S.Wrapper $isChecked={checked} $isCheckboxType={isCheckboxType} {...rest}>
      <input {...inputProps} />
      {children}

      {isCheckboxType && !isCheckIconHidden ? (
        <S.Checkbox
          className={`option-checkbox${checked ? ' checked' : ''}`}
          aria-checked={checked}
        >
          {checked ? <SvgImage svg={checkIcon} /> : null}
        </S.Checkbox>
      ) : null}
    </S.Wrapper>
  )
}
